const INTEGRATIONS = [
  {code:"PS",name:"PrestaShop",cat:"E-commerce",color:"#0f6e56",bg:"var(--gl)",status:"active",sync:"il y a 4 min · 12 commandes"},
  {code:"ST",name:"Stripe",cat:"Paiements",color:"#534ab7",bg:"#eeedfe",status:"active",sync:"Temps réel · 3 transactions"},
  {code:"PF",name:"PayFit",cat:"Paie",color:"#e55c1d",bg:"#faeeda",status:"active",sync:"Mensuel · Mai importé"},
  {code:"QT",name:"Qonto",cat:"Banque",color:"#185fa5",bg:"#e6f1fb",status:"active",sync:"Temps réel"},
  {code:"SH",name:"Shopify",cat:"E-commerce",color:"#3b6d11",bg:"#eaf3de",status:"config",sync:null},
  {code:"SF",name:"Salesforce",cat:"CRM",color:"#a32d2d",bg:"#fcebeb",status:"config",sync:null},
  {code:"WC",name:"WooCommerce",cat:"E-commerce",color:"#7c3aed",bg:"#eeedfe",status:"config",sync:null},
  {code:"GC",name:"GoCardless",cat:"Prélèvements SEPA",color:"#854f0b",bg:"var(--amber-light)",status:"config",sync:null},
  {code:"API",name:"API REST",cat:"Intégration custom",color:"var(--text-muted)",bg:"#f3f4f6",status:"doc",sync:null},
];
export default function Integrations() {
  return (
    <div>
      <div className="page-header"><h2 className="page-title">Intégrations & connecteurs</h2></div>
      <p style={{fontSize:13,color:"var(--text-muted)",marginBottom:20}}>Connectez vos outils métiers pour une comptabilité automatisée — PrestaShop, Stripe, CRM, paie, banques.</p>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
        {INTEGRATIONS.map(int=>(
          <div key={int.code} style={{padding:16,background:"#fff",border:`${int.status==="active"?"0.5px solid rgba(26,158,114,0.3)":"var(--border)"}`,borderRadius:10,cursor:"pointer"}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
              <div style={{width:36,height:36,borderRadius:9,background:int.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,color:int.color,flexShrink:0}}>{int.code}</div>
              <div style={{flex:1}}><div style={{fontSize:13,fontWeight:700}}>{int.name}</div><div style={{fontSize:11,color:"var(--text-muted)"}}>{int.cat}</div></div>
              <span className={`badge ${int.status==="active"?"success":int.status==="config"?"draft":"info"}`}>{int.status==="active"?"Actif":int.status==="config"?"À configurer":"Voir docs"}</span>
            </div>
            {int.sync&&<div style={{fontSize:11,color:"var(--g)",display:"flex",alignItems:"center",gap:5}}>🔄 {int.sync}</div>}
            {int.status!=="active"&&<button className="btn primary" style={{width:"100%",marginTop:8,fontSize:12}}>Connecter</button>}
          </div>
        ))}
      </div>
    </div>
  );
}
